import { fetchFuelSurchargeList } from ".";

interface RequestParameters {
  currentPage: number,
  pageSize: number,
  setItems: (data: any) => void,
  setFilteredContent: (content: any) => void,
  setLoading: (loading: boolean) => void
}

export default function getData({
  currentPage,
  pageSize,
  setLoading,
  setItems,
  setFilteredContent,
}: RequestParameters) {
  setLoading(true);
  fetchFuelSurchargeList({ page: currentPage, pageSize })
    ?.then((response: any) => {
      if(!response?.data?.is_error) {
        setItems(response?.data?.content?.data);
        setFilteredContent(response?.data?.content);
      }
    })
    .finally(() => setLoading(false))
}
